<div>
  <kendo-grid #masterInvalidGrid [kendoGridBinding]="gridView" [scrollable]="'true'" [resizable]="true"
    [sortable]="true" [pageable]="true" [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
    [filter]="gridState.filter" id="adjustment-main-grid" [rowSelected]="isRowSelected"
    [selectable]="{enabled: true, checkboxOnly: true}" (selectionChange)="onInvalidMasterSelectionChange($event)"
    [(expandedDetailKeys)]="expandedDetailKeys">
    <!-- TOOLBAR TEMPLATE -->
    <ng-template kendoGridToolbarTemplate>
      <div class="row bottom-margin-0">
        <div class="col m8 l8 xl6 margin-5 width-100p">
          <!-- DELETE RECORD -->
          <button kendoButton class="btn btn-fullwidth background-red right-margin-5" (click)="deleteBtnClicked(true)"
            [disabled]="!enableInvalidDeleteBtn || (gridView && gridView.length === 0)">Delete</button>
        </div>
      </div>
    </ng-template>
    <!-- MOBILE VIEW -->
    <kendo-grid-column media="(max-width: 772.98px)" title="Details">
      <ng-template kendoGridCellTemplate let-dataItem>
        <dl>
          <dd>
            <div class="align-left">
              <span class="bold">SSN4: </span>
              <span> {{ dataItem.lastFourSSN }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Last Name: </span>
              <span> {{ dataItem.lastName }}</span>
            </div>
          </dd>
        </dl>
      </ng-template>
    </kendo-grid-column>
    <!-- DETAIL VIEW -->
    <ng-template kendoGridDetailTemplate let-dataItem>
      <div class="row bottom-margin-5">
        <div class="col s12 m12 l12 xl12 padding-0">
          <app-invalid-detail-view [data]="dataItem" [adjustmentInputs]="adjustmentInputData"
            [accessOperators]="operators" [disableChild]="isParentSelected(dataItem)"
            (childDeletedRecord)="childDeleteAction($event)" (editAction)="editHandler($event)">
          </app-invalid-detail-view>
        </div>
      </div>
    </ng-template>
    <!-- PARENT CHECK BOX -->
    <kendo-grid-checkbox-column [width]="40">
      <ng-template kendoGridHeaderTemplate let-idx="rowIndex" let-dataItem *ngIf="gridView && gridView.length > 0">
        <div class="align-center">
          <input class="k-checkbox" type="checkbox" kendoGridSelectAllCheckbox id="selectAllCheckboxId">
          <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
        </div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
        <div class="align-center">
          <input [kendoGridSelectionCheckbox]="idx" class="k-checkbox" type="checkbox" id="{{'invalidChk'+idx}}" />
          <label class="k-checkbox-label" for="{{'invalidChk'+idx}}"></label>
        </div>
      </ng-template>
    </kendo-grid-checkbox-column>
    <!-- SSN COLUMN -->
    <kendo-grid-column media="(min-width: 773px)" field="lastFourSSN" [headerClass]="{'align-center': true}"
      class="align-center" title="SSN4" [width]="80">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          {{dataItem.lastFourSSN}}
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- LAST NAME -->
    <kendo-grid-column media="(min-width: 773px)" field="lastName" title="Last Name" [width]="100">
    </kendo-grid-column>

    <!-- ERROR STATUS -->
    <kendo-grid-column media="(min-width: 773px)" field="errorCount" title="Error Count"
      [headerStyle]="{'text-align': 'center'}" [width]="100" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          <span>{{dataItem.errorCount}}</span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- WARNING STATUS -->
    <kendo-grid-column media="(min-width: 773px)" field="issueCount" title="Warning Count"
      [headerStyle]="{'text-align': 'center'}" [width]="100" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          <span>{{dataItem.issueCount}}</span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="buttonCount"></kendo-pager-numeric-buttons>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-info></kendo-pager-info>
    </ng-template>
  </kendo-grid>
</div>
